export default __webpack_public_path__ + "static/media/content_tab02_03.3b7a1aae.png";